
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"phoenixDiningSearchBestRestaurantsByGeolocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantGeolocationSearchInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchRestaurantsByGeolocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"media"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageConnection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alternateDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPrimaryArchitectural"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPrimaryServices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSecondaryArchitectural"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSecondaryServices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"square"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"classicHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"classicVertical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deviceSmall"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureVertical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"panoramicHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"panoramicVertical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wideHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wideVertical"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cuisine"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1072}};
    doc.loc.source = {"body":"query phoenixDiningSearchBestRestaurantsByGeolocation(\n  $search: RestaurantGeolocationSearchInput!\n  $limit: Int\n  $offset: Int\n) {\n  searchRestaurantsByGeolocation(search: $search, limit: $limit, offset: $offset) {\n    edges {\n      node {\n        name\n        seoUrl\n        media {\n          imageConnection {\n            total\n            edges {\n              node {\n                title\n                alternateDescription\n                isPrimaryArchitectural\n                isPrimaryServices\n                isSecondaryArchitectural\n                isSecondaryServices\n                imageUrls {\n                  square\n                  classicHorizontal\n                  classicVertical\n                  deviceSmall\n                  featureHorizontal\n                  featureVertical\n                  flex\n                  panoramicHorizontal\n                  panoramicVertical\n                  wideHorizontal\n                  wideVertical\n                }\n              }\n            }\n          }\n        }\n        cuisine\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["phoenixDiningSearchBestRestaurantsByGeolocation"] = oneQuery(doc, "phoenixDiningSearchBestRestaurantsByGeolocation");
        
